export default __webpack_public_path__ + "static/media/placeholder_private03-fr-web.fe79b8b0.png";